/* Custom walkthrough player: play/pause, replay, autoplay-in-view. No scrubber,
   no volume slider, no fullscreen chrome -- deliberately four things only.
   Autoplay is muted because every browser blocks sound without a gesture, so the
   first click anywhere on the player turns the sound on. */
(function () {
  var IDLE_MS = 2400;

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function init(root) {
    if (root.dataset.apReady) return;
    root.dataset.apReady = '1';

    var video = root.querySelector('video');
    if (!video) return;

    var fill = root.querySelector('[data-ap-fill]');
    var time = root.querySelector('[data-ap-time]');
    var hint = root.querySelector('[data-ap-sound]');
    var idleTimer;

    video.controls = false;
    video.setAttribute('playsinline', '');
    video.removeAttribute('loop');

    function paint() {
      root.classList.toggle('is-paused', video.paused);
      root.classList.toggle('is-playing', !video.paused);
      if (video.paused) {
        root.classList.remove('is-idle');
        clearTimeout(idleTimer);
      }
    }

    function progress() {
      var d = video.duration;
      if (fill && isFinite(d) && d > 0) fill.style.width = (video.currentTime / d) * 100 + '%';
      if (time) time.textContent = fmt(video.currentTime) + (isFinite(d) ? ' / ' + fmt(d) : '');
    }

    function unmuteOnce() {
      if (!video.muted) return;
      video.muted = false;
      video.volume = 1;
      if (hint) hint.hidden = true;
    }

    function toggle() {
      if (video.preload === 'none') { video.preload = 'auto'; video.load(); }
      unmuteOnce();
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    }

    root.querySelectorAll('[data-ap-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
    });

    var replay = root.querySelector('[data-ap-replay]');
    if (replay) {
      replay.addEventListener('click', function (e) {
        e.preventDefault();
        unmuteOnce();
        video.currentTime = 0;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    if (hint) hint.addEventListener('click', function (e) { e.preventDefault(); unmuteOnce(); });

    video.addEventListener('click', function () { toggle(); });
    video.addEventListener('play', paint);
    video.addEventListener('pause', paint);
    video.addEventListener('ended', function () {
      // land on the replay state rather than a frozen last frame
      root.classList.add('is-paused');
      root.classList.remove('is-playing', 'is-idle');
    });
    video.addEventListener('timeupdate', progress);
    video.addEventListener('loadedmetadata', progress);

    // let the bar fade while it is actually playing, come back on any movement
    function wake() {
      root.classList.remove('is-idle');
      clearTimeout(idleTimer);
      if (!video.paused) {
        idleTimer = setTimeout(function () { root.classList.add('is-idle'); }, IDLE_MS);
      }
    }
    root.addEventListener('mousemove', wake);
    root.addEventListener('mouseleave', function () {
      if (!video.paused) root.classList.add('is-idle');
    });
    root.addEventListener('focusin', wake);

    paint();
    progress();

    // autoplay only once it is genuinely on screen, and stop when it leaves
    // phones never autoplay: the walkthrough is 20MB+, so it waits for a tap
    var mobile = window.matchMedia('(max-width: 749px)').matches || (navigator.connection && navigator.connection.saveData);
    if (!mobile && root.hasAttribute('data-ap-autoplay') && 'IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            // the element ships with preload="none" so a 40MB walkthrough is not
            // pulled down on page load; start fetching only once it is on screen
            if (video.preload === 'none') {
              video.preload = 'auto';
              video.load();
            }
            if (video.paused) {
              video.muted = true; // required, or the browser refuses
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
              started = true;
            }
          } else if (started && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      io.observe(root);
    }
  }

  function boot() {
    document.querySelectorAll('[data-ap-player]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // theme editor re-renders the section
  document.addEventListener('shopify:section:load', boot);
})();
